__webpack_require__.p = "/wp-content/plugins/activia-ght/gut-health-tracker/build/";